import { render, staticRenderFns } from "./SaiPagination.vue?vue&type=template&id=36dfd392"
import script from "./SaiPagination.vue?vue&type=script&lang=js"
export * from "./SaiPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports